"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateMachine = void 0;
exports.createCommonStateManager = createCommonStateManager;
class StateMachine {
    constructor(config) {
        var _a;
        this.subscribers = [];
        this.currentState = (_a = config.inititialState) !== null && _a !== void 0 ? _a : { state: 'IDLE' };
        this.stateList = config.stateList;
    }
    init(state) {
        this.setState(state);
    }
    getCurrentState() {
        return this.currentState;
    }
    isValidTransition({ state: nextStateInput }) {
        var _a;
        return !!((_a = this.stateList[this.currentState.state]) === null || _a === void 0 ? void 0 : _a.transitions.some(transition => transition === nextStateInput));
    }
    onExit(callback) {
        callback();
    }
    onEnter() {
        // implement later
    }
    onUpdate() {
        this.subscribers.forEach(callback => callback(this.currentState));
    }
    setSubscribers(subscribers) {
        this.subscribers = subscribers;
    }
    setState(nextState) {
        this.currentState = {
            state: nextState.state,
            type: nextState.type,
            data: nextState.data,
        };
        this.onUpdate();
    }
    onTransition(nextState, callback) {
        if (nextState.state === this.currentState.state && nextState.type === this.currentState.type) {
            return;
        }
        const isValid = this.isValidTransition(nextState);
        if (isValid) {
            callback && this.onExit(callback);
            this.setState(nextState);
            this.onEnter();
        }
        else {
            throw new Error(`Invalid state transition for: ${this.currentState.state}`);
        }
    }
}
exports.StateMachine = StateMachine;
function createCommonStateManager(config) {
    return new StateMachine(config);
}
//# sourceMappingURL=StateMachine.js.map